module.exports = __webpack_public_path__ + "media/images/img_side_seminar-a373166f8a9745c9607e85d825f6fd79.png";